<template>
    <div>
        <h1>page list</h1>

        <CampaignList
                v-if="listConfig"
                :lbl="lbl"
                :isLoading='isLoading'
                :initListConfig="listConfig"
                :initFilterConfig="filterConfig"
                :busEvent="busCampaign"
        ></CampaignList>
    </div>
</template>
<script>
import Vue from "vue";
import Locale from "@/helper/locale/locale.js";
import CampaignList from "./component/CampaignList.vue";
import {
  CampaignListConfigBuilder,
  CampaignListFilterConfigBuilder
} from "@/core/Campaign/model/CampaignConfigModel.js";

export default {
    name: "PageList",
    components: {
        CampaignList,
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            isLoading: false,
            listConfig: null,
            filterConfig: null,
            busCampaign: new Vue(),
        };
    },
    created: function() {
        this.initialConfig();
    },
    activated: function() {
        // console.log('list');
    },
    methods: {
        initialConfig: function() {
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList('campaign_singhaonline')
                .setTop(25)
                .create();
            this.listConfig = listConfig;

            var filterConfig = new CampaignListFilterConfigBuilder().create();
            this.filterConfig = filterConfig;
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
